import { render, staticRenderFns } from "./setStaple.vue?vue&type=template&id=d541a31c&scoped=true&"
import script from "./setStaple.vue?vue&type=script&lang=js&"
export * from "./setStaple.vue?vue&type=script&lang=js&"
import style0 from "./setStaple.vue?vue&type=style&index=0&id=d541a31c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d541a31c",
  null
  
)

export default component.exports